import Unita from "@/models/unita.model.js";

export default class Sito{

    CodiceSito;
    idCompany;
    Stato;
    DescrizioneOperativa;
    CodiceAzienda;
    RagioneSocialeAzienda;
    Tipologia;
    Indirizzo;
    Localita;
    Citta;
    CAP;
    Comune;
    Provincia;
    Nazione;
    Riferimento;
    Telefono;
    EMail;
    Note;
    SysChiaveglobale;
    Unita;

    constructor(){}

}